import { Icon } from "@coverme/icons";
import { getFormattedNameFromObject } from "../../services/stringService";
import React from "react";
import { first } from "lodash-es";

export function MiniFacesheetHousehold({ countableMembers, nonCountableMembers, household }) {
    return (
        <>
            <div>
                <h3 className="sub-heading">Countable</h3>
                {countableMembers.map((member, i) => {
                    const currentHouseholdMember = household.members.filter(x => x.personId === member.personId)[0];
                    return (
                        <p className="mini-facesheet__household-name" key={i}>
                            <span className="household-member-name">{getFormattedNameFromObject(member)} </span>
                            <span className="h4">({member.relationshipToPatient})</span>
                            {member.pregnancy?.expectedChildren > 0 && currentHouseholdMember?.countsAs > 1 && (
                                <span className="mini-facesheet__baby">
                                    <span>
                                        <Icon icon={"baby"} color={"blue"} height={15} width={25} />
                                    </span>
                                    <span className="h4">+ {member.pregnancy?.expectedChildren}</span>
                                </span>
                            )}
                        </p>
                    );
                })}
            </div>
            {nonCountableMembers.length > 0 && (
                <>
                    <hr className="section-separator" />
                    <div>
                        <h3 className="sub-heading">Non Countable</h3>
                        {nonCountableMembers.map((member, i) => {
                            return (
                                <p className="mini-facesheet__household-name" key={i}>
                                    {getFormattedNameFromObject(member)}
                                    <span className="h4"> ({member.relationshipToPatient})</span>
                                </p>
                            );
                        })}
                    </div>
                </>
            )}
        </>
    );
}
